<template>
  <div class="onboarding-down-payment-bg" v-if="transaction">
    <div class="onboarding-complete--container">

      <div class="onboarding-complete--header">
        <div class="prclx-logo">
          <asset-v3
            dir="logos"
            name="logo.svg"
          />
        </div>
      </div>

      <div class="content">
        <div class="success--message">
          <div class="check--icon">
            <CheckIcon size="16" color="#10B981" />
          </div>

          <div>
            <h4 class="white">Pedido confirmado</h4>
            <p class="mt-4 small-regular white">Nº: {{ transaction.orderId }}</p>
          </div>
        </div>

        <div class="onboarding-complete--content">
          <p class="body-regular gray-900">Agradecemos sua compra com o Parcelex.</p>
          <p class="body-regular gray-900 mt-8">
            Já está tudo certo com o seu pedido, agora basta aproveitar sua compra e acompanhar as
            próximas parcelas.
          </p>
        </div>
      </div>

      <div class="onboarding-complete--footer">
        <round-button
          class="primary round-button"
          @click="goToPortal"
          content="Ver minhas parcelas"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { CheckIcon } from '@vue-hero-icons/outline';
import AssetV3 from '@/components/common/AssetV3.vue';
import RoundButton from '../../paymentLink/components/RoundButton.vue';

export default {
  name: 'v2-onboarding-complete',
  components: {
    CheckIcon,
    AssetV3,
    RoundButton,
  },
  computed: {
    ...mapState('onboardingV2', ['transaction']),
  },
  methods: {
    async goToPortal() {
      await this.$router.push('/portal');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .onboarding-down-payment-bg {
    width: 100%;
    min-height: 100vh;

    @media (min-width: $breakpoint-large) {
      background-color: $gray-50;
      padding-top: 22px;
      padding-bottom: 1px;
    }
  }

  .onboarding-complete--container {
    display: grid;
    grid-template-rows: 76px 1fr 76px;
    background-color: $white;
    box-sizing: border-box;
    width: 100%;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);

    @media (min-width: $breakpoint-large) {
      margin: 0px auto 24px auto;
      max-width: 512px;
      border: 1px solid $gray-300;
      border-radius: 12px;
      box-shadow:
        0px 2px 4px -2px rgba(24, 39, 75, 0.12),
        0px 4px 4px -2px rgba(24, 39, 75, 0.08);
      min-height: auto;
      height: auto;
      overflow: hidden;
      padding-bottom: 14px;
    }
  }

  .prclx-logo {
    padding: 20px 24px 24px 24px;

    @media (min-width: $breakpoint-large) {
      text-align: center;
    }
  }

  .success--message {
    display: flex;
    gap: 12px;
    background-color: $green-500;
    padding: 22px 24px 20px 24px;

    @media(min-width: $breakpoint-large) {
      margin: 0 36px;
      border-radius: 6px;
    }

    h4 {
      font-family: 'Usual';
    }

    .check--icon {
      background-color: $white;
      height: 24px;
      min-height: 24px;
      width: 24px;
      min-width: 24px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .onboarding-complete--content {
    padding: 24px;

    @media(min-width: $breakpoint-large) {
      padding: 20px 36px;
    }
  }

  .onboarding-complete--footer {
    text-align: center;
    padding: 0px 24px;

    @media(min-width: $breakpoint-large) {
      background-color: $gray-50;
      padding: 24px 0px;
      height: calc(100% + 14px);
    }
  }

  ::v-deep .round-button {
    max-width: none;

    @media(min-width: $breakpoint-large) {
      width: auto;
    }
  }
</style>
